import type { Row } from '@tanstack/react-table';
import type { ReactNode } from 'react';

import { IconButton } from '../../../Button';
import type { DataWithRowId } from '../../types';

interface ExpandIconProps<T extends object, K extends object = T> {
  row: Row<DataWithRowId<T, K>>;
}

export const ExpandIcon = <T extends object, K extends object = T>({ row }: ExpandIconProps<T, K>): ReactNode => {
  // Only show expand icon for top-level rows
  if (row.depth > 0) {
    return null;
  }

  const record = row.original;
  const hasNestedItems: boolean = (record.nestedRowItems as K[] | undefined)?.length ? true : false;

  // Only show expand icon if the row has nested items to expand
  if (!hasNestedItems) {
    return null;
  }

  const chevronDirection: 'down' | 'right' = row.getIsExpanded() ? 'down' : 'right';

  return (
    <IconButton icon={`zicon-chevron-${chevronDirection}`} onClick={() => row.toggleExpanded()} size="medium" variant="ghost" />
  );
};
